import api from '@/api';

const { $pricing, $core } = api;

export const { $communities, $benefits } = $pricing;
export const { $users } = $core;
